import { useNavigate } from "react-router-dom";
import { comicTags } from "@/mocks/comics";

export default function Footer() {
  const navigate = useNavigate();

  const link = (label: string, path: string) => (
    <button
      key={label}
      onClick={() => navigate(path)}
      className="text-left text-sm text-background-300/90 transition-colors hover:text-accent-300 cursor-pointer"
    >
      {label}
    </button>
  );

  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="container-x grid grid-cols-1 gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        {/* 品牌 */}
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-brush-4-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-background-50">古风漫画网</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300/90">
            专注古言、宫斗、权谋、武侠、仙侠、江湖全题材古风国漫，分类清晰、每日更新，为每一位古风漫画爱好者守护一方故事天地。
          </p>
          <div className="mt-5 flex gap-3">
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300 cursor-pointer" aria-label="微信公众号">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300 cursor-pointer" aria-label="新浪微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300 cursor-pointer" aria-label="哔哩哔哩">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>

        {/* 快速导航 */}
        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-background-50">
            <span className="h-px w-4 bg-accent-400"></span>快速导航
          </h4>
          <div className="grid grid-cols-1 gap-2.5">
            {link("首页", "/")}
            {link("全部漫画", "/category")}
            {link("题材专题", "/topics")}
            {link("关于我们", "/about")}
            {link("联系我们", "/contact")}
          </div>
        </div>

        {/* 题材分类 */}
        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-background-50">
            <span className="h-px w-4 bg-accent-400"></span>题材分类
          </h4>
          <div className="grid grid-cols-2 gap-2.5">
            {comicTags.map((tag) => (
              <button
                key={tag}
                onClick={() => navigate(`/category?tag=${encodeURIComponent(tag)}`)}
                className="text-left text-sm text-background-300/90 transition-colors hover:text-accent-300 cursor-pointer"
              >
                {tag}漫画
              </button>
            ))}
          </div>
        </div>

        {/* 联系 */}
        <div>
          <h4 className="mb-4 flex items-center gap-2 font-heading text-base font-bold text-background-50">
            <span className="h-px w-4 bg-accent-400"></span>联系我们
          </h4>
          <ul className="space-y-2.5 text-sm text-background-300/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400"></i>gufengmanga@example.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-400"></i>每日 09:00 - 22:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-chat-smile-3-line text-accent-400"></i>客服随时在线答疑
            </li>
          </ul>
          <a href="/contact" onClick={(e) => { e.preventDefault(); navigate("/contact"); }} className="mt-5 inline-flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer">
            与我们联系<i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-400 sm:flex-row">
          <p>© 2026 古风漫画网 · 陪你追更每一部古风国漫</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-400"></i>
            内容仅供阅读分享，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}